import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const StartIcon = forwardRef<SVGSVGElement, IconProps>(function StartPollingIcon(
  { color = '', height = 18, width = 18, ...props },
  ref,
) {
  return (
    <SvgStyled
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...props}
    >
      <path
        d="M13.2048 7.62093C14.2651 8.30761 14.2651 9.69239 13.2048 10.3791L8.14163 13.6585C6.8428 14.4997 5 13.6908 5 12.2794L5 5.72059C5 4.30921 6.8428 3.50028 8.14163 4.34152L13.2048 7.62093Z"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
